import script from "./Setup.vue?vue&type=script&setup=true&lang=js"
export * from "./Setup.vue?vue&type=script&setup=true&lang=js"

import "./Setup.vue?vue&type=style&index=0&id=3bff0b13&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bff0b13"]])

export default __exports__